import * as React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slider.css";

interface Gallery {
    name: string,
    color?: string,
    images: string[],
}

interface SlideshowProps {
    config: {
        galleries: Gallery[],
        size: string,
        title?: string,
    }
}

interface SlideshowState {
    gallery: Gallery,
}

/**
 * Großer grüner Button
 */
export class Slideshow extends React.Component<SlideshowProps> {

    slider: Slider;

    state: SlideshowState = {
        gallery: null,
    }

    constructor(props: SlideshowProps) {
        super(props);

        props.config.galleries.map((gallery: Gallery) => {
            if (!this.state.gallery) {
                this.state.gallery = gallery;
            }
        })
    }

    isColorBright(c: string) {
        c = c.substring(1);      // strip #
        const rgb = parseInt(c, 16);   // convert rrggbb to decimal
        const r = (rgb >> 16) & 0xff;  // extract red
        const g = (rgb >>  8) & 0xff;  // extract green
        const b = (rgb >>  0) & 0xff;  // extract blue

        const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

        return luma > 200;
    }

    render() {

        //Slider konfigurieren
        const sliderSettings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            touchMove: true,
        };

        if (!this.state.gallery) {
            return '';
        }

        return <div className={"container"}>
            <div className={"slick-slider-container v2"}>

                {this.props.config.title &&
                <div className="av-special-heading av-special-heading-h2  blockquote modern-quote">
                    <h2 className={"av-special-heading-tag"}>{this.props.config.title}</h2>
                </div>
                }

                {this.props.config.galleries.length > 1 &&
                <div>
                    {this.props.config.galleries.map((gallery: Gallery, id: number) => {

                        let style = {
                        };
                        if (gallery.color) {
                            style = {
                                backgroundColor: gallery.color,
                                color: this.isColorBright(gallery.color) ? '#333333' : '#ffffff',
                            };

                        }

                        return <button key={id} style={style}
                                       className={"switch " + (gallery != this.state.gallery ? 'inactive' : 'active')}
                                       onClick={() => this.setState({gallery: gallery})}>{gallery.name}</button>
                    })}
                </div>
                }

                <Slider ref={slider => (this.slider = slider)} {...sliderSettings}>
                    {this.state.gallery.images.map((src, id) => {
                        return <div key={id}>
                            <img className={this.props.config.size} src={src} alt={""}/>
                        </div>
                    })}
                </Slider>
            </div>
        </div>;
    }
}